import React from 'react';
import {  Row, Col, Image } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import logo1 from '../Img/Bharat-Rug Logo.jpg';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer custom-bg text-light pt-3">
      {/* Top Bar */}
      <div className="text-center fw-bold">
        <Image src={logo1} alt="logo" className="brand-logo" roundedCircle />
                
                <p className="mt-2">Sourcing & Buying Agencies</p>
                <h2>Bharat Rug Agencies</h2>
      </div>
      <section>
        <div className="text-center text-md-start">
          <Row className="mx-2">
            {/* Column 1 */}
            <Col md={3} sm={6} xs={12} className="mx-auto">
              {/* <h4 className="text-uppercase fw-bold mb-4">Bharat Rug Agencies</h4> */}
              <h5 className="text-uppercase fw-bold text-center">Our Network</h5>
              <p className='text-center'>
                Panipat | New Delhi <br /> Agra | Jaipur <br />Lucknow | Sitapur <br />Varanasi | Mirzapur
              </p>
            </Col>

            {/* Column 2 */}
            <Col md={3} sm={6} xs={12} className="mx-auto">
              <h5 className="text-uppercase fw-bold text-center">Registered Office</h5>
              <p className="text-center" style={{ textIndent: "-1.5rem" }}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>Ramsahaypur<br/> Bhadohi - 221401 <br/> Uttar Pradesh <br/> India.</p>
            </Col>

            {/* Column 3 */}
            <Col md={3} sm={6} xs={12} className="mx-auto">
              <h5 className="text-uppercase fw-bold text-center" style={{ textIndent: "-1.5rem" }}>Branch Office</h5>

              <p className='text-center' style={{ textIndent: "-1.5rem" }}>
                {/* <a href="mailto:info@catustechnologies.com" className="footer-link"> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
              </svg>
                  <span className='mx-2'> First Floor- Shop No. 49<br/> Bida Mart, Rajpura <br/> Bhadohi-221401</span>
                {/* </a> */}
              </p>
              {/* <p className='' style={{ textIndent: "-1.5rem" }}>
                <a href="tel:+919899712724" className="footer-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-telephone-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                  </svg>
                  <span className='mx-2'>+91-945-300-1175</span>
                </a>
              </p> */}
            </Col>
          </Row>
        </div>
      </section>

      {/* Bottom Bar */}
      <div className="text-center border-top fw-bold">
        All Rights Reserved © 2025 BharatRugAgencies.com
      </div>
    </footer>
  );
}
